import { Grid, Typography } from "@material-ui/core";
import CostoItem from "./CostoItem";
import CostosSkeleton from "./CostosSkeleton";
import { Cost } from "../../../interfaces/costs/costs.interface";
import NoCostsFound from "./NoCostsFound";
import GridContainerPagination from "../../../components/common/grid-pagination/GridContainerPagination";

interface props {
  isLoading: boolean;
  costs: Cost[];
  total: string;
}

const CostosContainer = ({ isLoading, costs, total }: props) => {
  if (isLoading) return <CostosSkeleton />;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Typography>Resultados: {total} </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          {costs.length === 0 && <NoCostsFound />}
        </Grid>
        {
          <GridContainerPagination
            // maxHeight={800}
            items={costs.map((cost, index) => (
              <CostoItem key={index} cost={cost} />
            ))}
          />
        }
        {/* {costs.map((cost, index) => (
          <Grid key={index} item xs={12} sm={4} md={4} lg={3} xl={2}>
            <CostoItem cost={cost} />
          </Grid>
        ))} */}
      </Grid>
    </>
  );
};

export default CostosContainer;
